export default function heightValidator(height: string | undefined) {
  if (height === '' || height === undefined) {
    return 'Высота не может быть пустой';
  }
  if (isNaN(Number(height))) {
    return 'Не удалось преобразовать высоту в число';
  }
  if (+height <= 0) {
    return 'Высота не может быть меньше или равна 0';
  }
  if (+height >= 10000) {
    return 'Высота не может быть больше или равна 10000';
  }
  return undefined;
}
